// TODO this logic is almost the same used in checkout. We should eventually move both to yos
import cardValidator from 'card-validator';

type CreditCardValues = {
    cardHolderName: string
    number: string
    expiryDateStr: string
    cvv: string
}

type MappedCreditCard = {
    cardHolderName: string
    cardNumber: string
    cardType: string
    cvsNumber: string
    expiryYear: number
    expiryMonth: number
    keepCard: string
}

const typeMap = [
    {
        validator: 'visa',
        gps: 'VISA'
    },
    {
        validator: 'american-express',
        gps: 'AMERICAN_EXPRESS'
    },
    {
        validator: 'diners-club',
        gps: 'DINERS'
    },
    {
        validator: 'jcb',
        gps: 'JCB'
    },
    {
        validator: 'unionpay',
        gps: 'UNION_PAY'
    },
    {
        validator: 'maestro',
        gps: 'MAESTRO'
    },
    {
        validator: 'mastercard',
        gps: 'MASTERCARD'
    },
    {
        validator: 'discover',
        gps: 'DISCOVER'
    }
]

export function mapCardType({ value, from, to }) {
    const type = typeMap.find((card) => card[from] === value)
    return type ? type[to] : undefined
}

export function validatorToGPS(value) {
    return mapCardType({
        value: value,
        from: 'validator',
        to: 'gps'
    })
}

export function mapCardToGPS(values: CreditCardValues): MappedCreditCard {
    const [expiryMonth, expiryYear] = values?.expiryDateStr?.split('/')
    const formattedExpiryYear = `20${expiryYear}`

    return {
        cardHolderName: values.cardHolderName.trim(),
        cardNumber: values.number?.replace(/\D/g, ''),
        cardType: validatorToGPS(cardValidator.number(values.number)?.card?.type),
        cvsNumber: values.cvv,
        expiryYear: parseInt(formattedExpiryYear, 10),
        expiryMonth: parseInt(expiryMonth, 10),
        keepCard: 'false',
    }
}
